document.addEventListener(
  'dialog:open',
  (event) => {
    const prompt = event.target instanceof Element ? event.target.closest('[data-ch-wotm-video-prompt]') : null;

    if (!prompt) return;

    const container = prompt.querySelector('[data-ch-wotm-video-container]');
    if (!(container instanceof HTMLElement)) return;

    const video = container.querySelector('video');

    if (video instanceof HTMLVideoElement) {
      if (video.readyState === HTMLMediaElement.HAVE_NOTHING) {
        video.load();
      }

      video.play().catch(() => {
        // Keep native controls available if the browser blocks autoplay.
      });
    }
  },
  { capture: true }
);

document.addEventListener(
  'dialog:close',
  (event) => {
    const prompt = event.target instanceof Element ? event.target.closest('[data-ch-wotm-video-prompt]') : null;

    if (!prompt) return;

    prompt.querySelectorAll('video').forEach((video) => {
      video.pause();
    });
  },
  { capture: true }
);
